export const useTransition = () => {
  const startEnterTransition = (el) => {
    const height = el.scrollHeight;
    el.style.maxHeight = "0";
    el.style.opacity = "0";
    el.style.transform = "translateY(-8px)";
    el.offsetHeight; // Force reflow
    el.style.maxHeight = `${height}px`;
    el.style.opacity = "1";
    el.style.transform = "translateY(0)";
    el.classList.add("transitioning_enter");
  };

  const startLeaveTransition = (el) => {
    const height = el.scrollHeight;
    el.style.maxHeight = `${height}px`;
    el.style.opacity = "1";
    el.style.transform = "translateY(0)";
    el.offsetHeight; // Force reflow
    el.style.maxHeight = "0";
    el.style.opacity = "0";
    el.style.transform = "translateY(8px)";
    el.classList.add("transitioning_leave");
  };

  const endTransition = (el) => {
    el.classList.remove("transitioning_enter", "transitioning_leave");
    el.style.maxHeight = "";
    el.style.opacity = "";
    el.style.transform = "";
  };

  const startEnterTransitionHorizontal = (el) => {
    const width = el.scrollWidth;
    el.style.maxWidth = "0";
    el.style.opacity = "0";
    el.style.transform = "translateX(-8px)";
    el.offsetWidth;
    el.style.maxWidth = `${width}px`;
    el.style.opacity = "1";
    el.style.transform = "translateX(0)";
    el.classList.add("transitioning_enter");
  };

  const startLeaveTransitionHorizontal = (el) => {
    const width = el.scrollWidth;
    el.style.maxWidth = `${width}px`;
    el.style.opacity = "1";
    el.style.transform = "translateX(0)";
    el.offsetWidth;
    el.style.maxWidth = "0";
    el.style.opacity = "0";
    el.style.transform = "translateX(-8px)";
    el.classList.add("transitioning_leave");
  };

  const endTransitionHorizontal = (el) => {
    el.classList.remove("transitioning_enter", "transitioning_leave");
    el.style.opacity = "";
    el.style.maxWidth = "";
    el.style.transform = "";
  };

  const startEnterTransitionHorizontalFromRight = (el) => {
    el.style.opacity = "0";
    el.style.transform = "translateX(100%)";
    el.offsetWidth;
    el.style.opacity = "1";
    el.style.transform = "translateX(0)";
    el.classList.add("transitioning_enter");
  };

  const startLeaveTransitionHorizontalToRight = (el) => {
    el.style.opacity = "1";
    el.style.transform = "translateX(0)";
    el.offsetWidth;
    el.style.opacity = "0";
    el.style.transform = "translateX(100%)";
    el.classList.add("transitioning_leave");
  };

  return {
    startEnterTransition,
    startLeaveTransition,
    endTransition,
    startEnterTransitionHorizontal,
    startLeaveTransitionHorizontal,
    endTransitionHorizontal,
    startEnterTransitionHorizontalFromRight,
    startLeaveTransitionHorizontalToRight,
  };
};
